"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var shell;
    (function (shell) {
        /**
         * @remarks Elements CANNOT overlap
         */
        // tslint:disable-next-line:class-name
        var multiElementSurroundingBlockingDiv = /** @class */ (function () {
            function multiElementSurroundingBlockingDiv(clickHandler, blockingDivClasses) {
                this.clickHandler = clickHandler;
                this.blockingDivClasses = blockingDivClasses;
                this.blocksShown = false;
                this.blockingDivs = [];
                if (!this.blockingDivClasses) {
                    this.blockingDivClasses = [];
                }
            }
            /**
             * Find the closest element within the range going in a certain direction
             */
            multiElementSurroundingBlockingDiv.findClosest = function (elements, currentIndex, begin, end, direction) {
                var isVertical = (direction === 8 /* up */ || direction === 2 /* down */);
                var currentOffset = $(elements[currentIndex]).offset();
                var currentValue;
                switch (direction) {
                    case 8 /* up */:
                        currentValue = currentOffset.top;
                        break;
                    case 2 /* down */:
                        currentValue = currentOffset.top + elements[currentIndex].offsetHeight;
                        break;
                    case 4 /* left */:
                        currentValue = currentOffset.left;
                        break;
                    case 6 /* right */:
                        currentValue = currentOffset.left + elements[currentIndex].offsetWidth;
                        break;
                }
                currentValue = Math.ceil(currentValue);
                var smallestDifference;
                var closestIndex;
                for (var i = 0; i < elements.length; i++) {
                    if (i !== currentIndex) {
                        var controlOffset = $(elements[i]).offset();
                        var controlBegin = isVertical ? controlOffset.left : controlOffset.top;
                        var controlEnd = isVertical ? (controlBegin + elements[i].offsetWidth) : (controlBegin + elements[i].offsetHeight);
                        // See if the control element starts or ends in the range or is a superset of the range
                        if ((controlBegin <= end && controlBegin >= begin) ||
                            (controlEnd <= end && controlEnd >= begin) ||
                            (controlBegin <= begin && controlEnd >= end)) {
                            // Need to decide what attribute to use for calculating how close it is to the currentValue
                            var difference = void 0;
                            switch (direction) {
                                case 8 /* up */:
                                    var controlBottom = Math.ceil(controlOffset.top + elements[i].offsetHeight);
                                    if (controlBottom <= currentValue) {
                                        difference = currentValue - controlBottom;
                                    }
                                    break;
                                case 2 /* down */:
                                    var controlTop = Math.ceil(controlOffset.top);
                                    if (controlTop >= currentValue) {
                                        difference = controlTop - currentValue;
                                    }
                                    break;
                                case 4 /* left */:
                                    var controlRight = Math.ceil(controlOffset.left + elements[i].offsetWidth);
                                    if (controlRight <= currentValue) {
                                        difference = currentValue - controlRight;
                                    }
                                    break;
                                case 6 /* right */:
                                    var controlLeft = Math.ceil(controlOffset.left);
                                    if (controlLeft >= currentValue) {
                                        difference = controlLeft - currentValue;
                                    }
                                    break;
                            }
                            if (difference !== undefined && (smallestDifference === undefined || difference < smallestDifference)) {
                                smallestDifference = difference;
                                closestIndex = i;
                            }
                        }
                    }
                }
                return { distance: smallestDifference, index: closestIndex };
            };
            multiElementSurroundingBlockingDiv.prototype.show = function (elements) {
                if (this.blockingDivs.length) {
                    this.destroy();
                }
                if (!elements || elements.length === 0) {
                    return;
                }
                var mainPane = $dyn.shell.mainPane;
                var mainPaneOffset = $(mainPane).offset();
                var mainPaneInfo = {
                    bottom: mainPaneOffset.top + mainPane.offsetHeight,
                    left: mainPaneOffset.left,
                    right: mainPaneOffset.left + mainPane.offsetWidth,
                    top: mainPaneOffset.top
                };
                for (var i = 0; i < elements.length; i++) {
                    var surroundingDiv = new $dyn.shell.surroundingBlockingDiv(this.clickHandler, this.blockingDivClasses);
                    surroundingDiv.init();
                    surroundingDiv.surroundedElement = elements[i];
                    var offset = $(elements[i]).offset();
                    var offsetHeight = elements[i].offsetHeight;
                    var offsetWidth = elements[i].offsetWidth;
                    var elementInfo = {
                        bottom: offset.top + offsetHeight,
                        height: offsetHeight,
                        index: i,
                        left: offset.left,
                        right: offset.left + offsetWidth,
                        top: offset.top,
                        width: offsetWidth
                    };
                    var divInfo = {
                        leftWidth: this.createLeftBlock(elements, surroundingDiv, elementInfo, mainPaneInfo),
                        rightWidth: this.createRightBlock(elements, surroundingDiv, elementInfo, mainPaneInfo)
                    };
                    this.createTopBlock(elements, i, surroundingDiv, elementInfo, mainPaneInfo, divInfo);
                    this.createBottomBlock(elements, i, surroundingDiv, elementInfo, mainPaneInfo, divInfo);
                    surroundingDiv.blocksShown = true;
                    this.blockingDivs.push(surroundingDiv);
                }
                this.blocksShown = true;
            };
            multiElementSurroundingBlockingDiv.prototype.display = function () {
                var e_1, _a;
                try {
                    for (var _b = __values(this.blockingDivs), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var blockingDiv_1 = _c.value;
                        blockingDiv_1.display();
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                this.blocksShown = true;
            };
            multiElementSurroundingBlockingDiv.prototype.hide = function () {
                var e_2, _a;
                try {
                    for (var _b = __values(this.blockingDivs), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var blockingDiv_2 = _c.value;
                        blockingDiv_2.hide();
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                this.blocksShown = false;
            };
            multiElementSurroundingBlockingDiv.prototype.destroy = function () {
                var e_3, _a;
                try {
                    for (var _b = __values(this.blockingDivs), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var blockingDiv_3 = _c.value;
                        blockingDiv_3.destroy();
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                this.blockingDivs.length = 0;
                this.blocksShown = false;
            };
            multiElementSurroundingBlockingDiv.prototype.addClass = function (className) {
                var e_4, _a;
                var currentIndex = this.blockingDivClasses.indexOf(className);
                if (currentIndex === -1) {
                    try {
                        for (var _b = __values(this.blockingDivs), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var blockingDiv_4 = _c.value;
                            blockingDiv_4.blockingDivClasses.push(className);
                            blockingDiv_4.addBlockingDivClasses();
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    this.blockingDivClasses.push(className);
                }
            };
            multiElementSurroundingBlockingDiv.prototype.removeClass = function (className) {
                var e_5, _a;
                var currentIndex = this.blockingDivClasses.indexOf(className);
                if (currentIndex > -1) {
                    try {
                        for (var _b = __values(this.blockingDivs), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var blockingDiv_5 = _c.value;
                            var index = blockingDiv_5.blockingDivClasses.indexOf(className);
                            if (index > -1) {
                                blockingDiv_5.blockingDivClasses.splice(index, 1);
                                blockingDiv_5.removeBlockingDivClass(className);
                            }
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                    this.blockingDivClasses.splice(currentIndex, 1);
                }
            };
            multiElementSurroundingBlockingDiv.prototype.addMessagingContent = function (element, content) {
                var e_6, _a;
                try {
                    for (var _b = __values(this.blockingDivs), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var blockingDiv_6 = _c.value;
                        if (element === blockingDiv_6.surroundedElement) {
                            blockingDiv_6.setMessagingContent(content);
                            if (content === null) {
                                blockingDiv_6.hideMessagingDiv();
                            }
                            else {
                                blockingDiv_6.showMessagingDiv(element);
                            }
                            break;
                        }
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            };
            multiElementSurroundingBlockingDiv.prototype.hasMessagingContent = function (element) {
                var e_7, _a;
                try {
                    for (var _b = __values(this.blockingDivs), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var blockingDiv_7 = _c.value;
                        if (element === blockingDiv_7.surroundedElement) {
                            return blockingDiv_7.messagingBlockUsed;
                        }
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
            };
            multiElementSurroundingBlockingDiv.prototype.createLeftBlock = function (elements, surroundingDiv, elementInfo, mainPaneInfo) {
                // Find how far away the closest element directly to the left within the vertical range of the control's top and bottom is
                var leftClosest = multiElementSurroundingBlockingDiv.findClosest(elements, elementInfo.index, elementInfo.top, elementInfo.bottom, 4 /* left */);
                var divWidth = leftClosest.distance;
                surroundingDiv.leftBlockUsed = true;
                if (divWidth === undefined) {
                    // Did not find an element to the left within that range
                    // Width of the left block will be from the the left edge of the main pane to the left edge of the element
                    divWidth = elementInfo.left - mainPaneInfo.left;
                }
                else if (divWidth === 0) {
                    // Two elements are touching so no need for a blocking div
                    surroundingDiv.leftBlockUsed = false;
                }
                else if (leftClosest.index !== undefined && this.blockingDivs.length > leftClosest.index && this.blockingDivs[leftClosest.index].rightBlockUsed) {
                    // Closest element to the left is already showing its right block
                    var rightBlockWidth = Math.ceil(this.blockingDivs[leftClosest.index].rightBlock[0].offsetWidth);
                    if (rightBlockWidth === divWidth) {
                        // Closest right block comes all the way to the left edge of the element, no need for left block
                        divWidth = 0;
                        surroundingDiv.leftBlockUsed = false;
                    }
                    else {
                        // Closest right block does not come all the way to element, create left block up until the end of the closest right block
                        divWidth -= rightBlockWidth;
                    }
                }
                if (surroundingDiv.leftBlockUsed) {
                    surroundingDiv.leftBlock.css({
                        "display": "block",
                        "height": elementInfo.height + "px",
                        "left": (elementInfo.left - divWidth) + "px",
                        "top": elementInfo.top + "px",
                        "width": divWidth + "px"
                    });
                }
                // return the width so the top/bottom blocks know how wide to be
                return divWidth;
            };
            multiElementSurroundingBlockingDiv.prototype.createRightBlock = function (elements, surroundingDiv, elementInfo, mainPaneInfo) {
                // Find how far away the closest element directly to the right within the vertical range of the control's top and bottom is
                var rightClosest = multiElementSurroundingBlockingDiv.findClosest(elements, elementInfo.index, elementInfo.top, elementInfo.bottom, 6 /* right */);
                var divWidth = rightClosest.distance;
                surroundingDiv.rightBlockUsed = true;
                if (divWidth === undefined) {
                    // Did not find an element to the right within that range
                    // Width of right block will be from the right edge of the element to the right edge of the main pane
                    divWidth = mainPaneInfo.right - elementInfo.right;
                }
                else if (divWidth === 0) {
                    // Two elements are touching so no need for a blocking div
                    surroundingDiv.rightBlockUsed = false;
                }
                else if (rightClosest.index !== undefined && this.blockingDivs.length > rightClosest.index && this.blockingDivs[rightClosest.index].leftBlockUsed) {
                    // Closest element to the right is already showing its left block
                    var leftBlockWidth = Math.ceil(this.blockingDivs[rightClosest.index].leftBlock[0].offsetWidth);
                    if (leftBlockWidth === divWidth) {
                        // Closest left block comes all the way to the right edge of the element, no need for right block
                        divWidth = 0;
                        surroundingDiv.rightBlockUsed = false;
                    }
                    else {
                        // Closest left block does not come all the way to element, create right block up until the end of the closest left block
                        divWidth -= leftBlockWidth;
                    }
                }
                if (surroundingDiv.rightBlockUsed) {
                    surroundingDiv.rightBlock.css({
                        "display": "block",
                        "height": elementInfo.height + "px",
                        "left": elementInfo.right + "px",
                        "top": elementInfo.top + "px",
                        "width": divWidth + "px"
                    });
                }
                // return the width so the top/bottom blocks know how wide to be
                return divWidth;
            };
            multiElementSurroundingBlockingDiv.prototype.createTopBlock = function (elements, index, surroundingDiv, elementInfo, mainPaneInfo, divInfo) {
                // Find how far away the closest element is above the region from the closest element to the left to the closest element to the right
                var upClosest = multiElementSurroundingBlockingDiv.findClosest(elements, index, elementInfo.left - divInfo.leftWidth, elementInfo.right + divInfo.rightWidth, 8 /* up */);
                var divHeight = upClosest.distance;
                surroundingDiv.topBlockUsed = true;
                if (divHeight === undefined) {
                    // Did not find an element above within that range
                    // Height of top block will be from the top edge of the element to the top edge of the main pane
                    divHeight = elementInfo.top - mainPaneInfo.top;
                }
                else if (divHeight === 0) {
                    // Two elements are touching so no need for a blocking div
                    surroundingDiv.topBlockUsed = false;
                }
                else if (upClosest.index !== undefined && this.blockingDivs.length > upClosest.index && this.blockingDivs[upClosest.index].bottomBlockUsed) {
                    // Closest element above is already showing its bottom block
                    var bottomBlockHeight = Math.ceil(this.blockingDivs[upClosest.index].bottomBlock[0].offsetHeight);
                    if (bottomBlockHeight === divHeight) {
                        // Closest bottom block comes all the way to the top edge of the element, no need for top block
                        divHeight = 0;
                        surroundingDiv.topBlockUsed = false;
                    }
                    else {
                        // Closest bottom block does not come all the way to element, create top block up until the bottom of the closest bottom block
                        divHeight -= bottomBlockHeight;
                    }
                }
                if (surroundingDiv.topBlockUsed) {
                    // Top block width is equal to the left block width + element width + right block width
                    var divWidth = divInfo.leftWidth + elementInfo.width + divInfo.rightWidth;
                    surroundingDiv.topBlock.css({
                        "display": "block",
                        "height": divHeight + "px",
                        "left": (elementInfo.left - divInfo.leftWidth) + "px",
                        "top": (elementInfo.top - divHeight) + "px",
                        "width": divWidth + "px",
                    });
                }
            };
            multiElementSurroundingBlockingDiv.prototype.createBottomBlock = function (elements, index, surroundingDiv, elementInfo, mainPaneInfo, divInfo) {
                // Find how far away the closest element is below the region from the closest element to the left to the closest element to the right
                var downClosest = multiElementSurroundingBlockingDiv.findClosest(elements, index, elementInfo.left - divInfo.leftWidth, elementInfo.right + divInfo.rightWidth, 2 /* down */);
                var divHeight = downClosest.distance;
                surroundingDiv.bottomBlockUsed = true;
                if (divHeight === undefined) {
                    // Did not find an element below within that range
                    // Height of bottom block will be from the bottom edge of the element to the bottom edge of the main pane
                    divHeight = mainPaneInfo.bottom - elementInfo.bottom;
                }
                else if (divHeight === 0) {
                    // Two elements are touching so no need for a blocking div
                    surroundingDiv.bottomBlockUsed = false;
                }
                else if (downClosest.index !== undefined && this.blockingDivs.length > downClosest.index && this.blockingDivs[downClosest.index].topBlockUsed) {
                    // Closest element below is already showing its top block
                    var topBlockHeight = Math.ceil(this.blockingDivs[downClosest.index].topBlock[0].offsetHeight);
                    if (topBlockHeight === divHeight) {
                        // Closest top block comes all the way to the bottom edge of the element, no need for bottom block
                        divHeight = 0;
                        surroundingDiv.bottomBlockUsed = false;
                    }
                    else {
                        // Closest top block does not come all the way to element, create bottom block up until the top of the closest top block
                        divHeight -= topBlockHeight;
                    }
                }
                if (surroundingDiv.bottomBlockUsed) {
                    // Bottom block width is equal to the left block width + element width + right block width
                    var divWidth = divInfo.leftWidth + elementInfo.width + divInfo.rightWidth;
                    surroundingDiv.bottomBlock.css({
                        "display": "block",
                        "height": divHeight + "px",
                        "left": (elementInfo.left - divInfo.leftWidth) + "px",
                        "top": elementInfo.bottom + "px",
                        "width": divWidth + "px",
                    });
                }
            };
            return multiElementSurroundingBlockingDiv;
        }());
        shell.multiElementSurroundingBlockingDiv = multiElementSurroundingBlockingDiv;
    })(shell = $dyn.shell || ($dyn.shell = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=MultiElementSurroundingBlockingDiv.js.map
